import { PropsWithChildren } from 'react';

export function LoadingStatus({ children }: PropsWithChildren) {
  return (
    <>
      <span role="status" className="sr-only">
        Loading…
      </span>
      {children}
    </>
  );
}
